/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteImageDto
 */
export interface DeleteImageDto {
    /**
     * S3 image URL to delete
     * @type {string}
     * @memberof DeleteImageDto
     */
    url: string;
}

/**
 * Check if a given object implements the DeleteImageDto interface.
 */
export function instanceOfDeleteImageDto(value: object): value is DeleteImageDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function DeleteImageDtoFromJSON(json: any): DeleteImageDto {
    return DeleteImageDtoFromJSONTyped(json, false);
}

export function DeleteImageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteImageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function DeleteImageDtoToJSON(value?: DeleteImageDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'url': value['url'],
    };
}

